import * as swcHelpers from '@swc/helpers';

function getProductBlockVariantInfo(product, variant, productType) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    const isLenses = productType === 'Contact-lenses' || productType === 'Contact-lens-bundles';
    const isSolutions = productType === 'Solutions';
    const brand = isLenses || isSolutions ? product.name.localized : (ref = variant.brand) === null || ref === void 0 ? void 0 : ref.name;
    const name = isLenses ? variant.replacementFrequency || '' : isSolutions ? `${variant.contactLensCareType || ''} ${variant.packageOption || ''}` : variant.name;
    const price = productType === 'Frames' && variant.priceIncludedAmount ? variant.priceIncludedAmount : (ref1 = variant.pricing) === null || ref1 === void 0 ? void 0 : ref1.price.originalPrice;
    const discount = ((ref2 = variant.pricing) === null || ref2 === void 0 ? void 0 : ref2.price.discount) && variant.pricing.price.discount.price !== variant.pricing.price.originalPrice ? {
        discountedPrice: (ref3 = variant.pricing) === null || ref3 === void 0 ? void 0 : ref3.price.discount.price
    } : {};
    return swcHelpers.objectSpread({
        brand,
        discounted: (ref5 = (ref4 = variant.pricing) === null || ref4 === void 0 ? void 0 : ref4.price.discount) === null || ref5 === void 0 ? void 0 : ref5.badge,
        name,
        sku: variant.sku,
        price,
        isCentAmount: (ref6 = variant.pricing) === null || ref6 === void 0 ? void 0 : ref6.price.isCentAmount,
        pricePerUnit: (ref7 = variant.pricing) === null || ref7 === void 0 ? void 0 : ref7.pricePerUnit,
        tag: variant.tag
    }, discount, {
        bestPrice: (ref8 = variant.pricing) === null || ref8 === void 0 ? void 0 : ref8.bestPrice
    });
}

export { getProductBlockVariantInfo };
//# sourceMappingURL=get-product-block-variant-info.js.map
